/**
 * Scroll to the next stage on click
 * @param {Event} event - The click event
 */
export const scrollToNext = (event) => {
    event.preventDefault()
    const targetId = event.target.getAttribute('href')
    let offsetY = -50

    if (event.target.dataset.scrollOffset === 'stage') {
        const introHeight = document.querySelector(`${targetId} .stage-introduction`).offsetHeight
        offsetY = -Math.min(window.innerHeight / 1.5, introHeight)
    }

    gsap.registerPlugin(ScrollTrigger)
    gsap.to(window, {
        duration: 2,
        scrollTo: {
            y: targetId,
            offsetY: offsetY,
        },
    })
}

export class ScrollToTop {
    /**
     * Constructor for the ScrollToTop class
     * @param {string} buttonSelector - Selector for the scroll-to-top button
     * @param {string} footerSelector - Selector for the footer (used for IntersectionObserver)
     */
    constructor(buttonSelector = '.scroll-to-top', footerSelector = '.site-footer') {
        this.scrollToTopBtn = document.querySelector(buttonSelector)
        this.footerSelector = footerSelector

        if (!this.scrollToTopBtn) {
            console.warn(`ScrollToTop button not found with selector: ${buttonSelector}`)
            return
        }

        this.init()
    }

    /**
     * Initialize the ScrollToTop functionality
     */
    init() {
        if (this.isUsingScrollTrigger()) {
            gsap.registerPlugin(ScrollTrigger)
            this.setupScrollTrigger()
        } else {
            this.setupIntersectionObserver()
        }

        this.scrollToTopBtn.addEventListener('click', (event) => this.scrollToTop(event))
    }

    /**
     * Check if ScrollTrigger is being used
     * @returns {boolean} - True if ScrollTrigger is available, false otherwise
     */
    isUsingScrollTrigger() {
        return typeof ScrollTrigger !== 'undefined'
    }

    /**
     * Set up ScrollTrigger for the scroll-to-top button
     */
    setupScrollTrigger() {
        ScrollTrigger.create({
            trigger: document.body,
            start: window.innerHeight * 2,
            end: () => Math.max(document.body.offsetHeight, 999999),
            toggleClass: {
                targets: this.scrollToTopBtn,
                className: 'active',
            },
        })
    }

    /**
     * Set up IntersectionObserver for the scroll-to-top button
     */
    setupIntersectionObserver() {
        const scrollTopTarget = document.querySelector(this.footerSelector)

        if (!scrollTopTarget) {
            console.warn(`Footer not found with selector: ${this.footerSelector}`)
            return
        }

        const scrollTopCallback = (entries) => {
            entries.forEach((entry) => {
                this.scrollToTopBtn.classList.toggle('active', entry.isIntersecting)
            })
        }

        const scrollTopObserver = new IntersectionObserver(scrollTopCallback)
        scrollTopObserver.observe(scrollTopTarget)
    }

    /**
     * Scroll to the top of the page
     * @param {Event} event - The click event
     */
    scrollToTop(event) {
        event.preventDefault()

        const target = event.currentTarget
        if (
            typeof gsap !== 'undefined' &&
            target.dataset.scrollTo !== 'undefined' &&
            !document.documentElement.classList.contains('scroll-smooth')
        ) {
            gsap.to(window, {
                duration: target.dataset.scrollDuration ?? 3,
                scrollTo: target.dataset.scrollTo || target.getAttribute('href'),
            })
        } else {
            document.documentElement.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        }
    }
}
